"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4284],{

/***/ 54541:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ScrollableStack = _interopRequireDefault(__webpack_require__(50902));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var __jsx = _react["default"].createElement;
var PhotoSlider = function PhotoSlider(props) {
  var slides = props.slides,
    buttonNext = props.buttonNext,
    buttonPrevious = props.buttonPrevious;
  return __jsx(_ScrollableStack["default"], {
    sx: {
      width: "100%",
      maxWidth: "100%",
      color: "white",
      $itemsVisible: [1.3, null, 1, null],
      $gap: 10
    },
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: function button(_ref2) {
          var buttonProps = _ref2.buttonProps;
          return __jsx(_Box["default"], {
            sx: {
              display: isAtStart ? "none" : "block"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(buttonPrevious, buttonProps));
        },
        offset: 20
      };
    },
    nextButton: function nextButton(_ref3) {
      var isAtEnd = _ref3.isAtEnd;
      return {
        button: function button(_ref4) {
          var buttonProps = _ref4.buttonProps;
          return __jsx(_Box["default"], {
            sx: {
              display: isAtEnd ? "none" : "block"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(buttonNext, buttonProps));
        },
        offset: 20
      };
    }
  }, slides.map(function (slide, index) {
    return __jsx(_Image["default"], {
      sx: {
        width: "100%",
        objectFit: "cover",
        aspectRatio: 1.33
      },
      key: index,
      image: slide,
      sizes: "(max-width: 1070px) and (min-width: 10px) 420px, 768px"
    });
  }));
};
var _default = PhotoSlider;
exports.Z = _default;

/***/ }),

/***/ 4284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ collection; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(56410);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Grid/index.js
var Grid = __webpack_require__(98290);
var Grid_default = /*#__PURE__*/__webpack_require__.n(Grid);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ./src/containers/UI/PageContainer/index.js + 2 modules
var PageContainer = __webpack_require__(73764);
// EXTERNAL MODULE: ../components-new/dist/Image/index.js
var Image = __webpack_require__(90451);
// EXTERNAL MODULE: ../components-new/dist/PhotoSlider/index.js
var PhotoSlider = __webpack_require__(54541);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/ButtonIcon/index.js
var ButtonIcon = __webpack_require__(7859);
var ButtonIcon_default = /*#__PURE__*/__webpack_require__.n(ButtonIcon);
;// CONCATENATED MODULE: ./src/icons/arrow-next.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgArrowNext(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  })));
}
/* harmony default export */ var arrow_next = (SvgArrowNext);
;// CONCATENATED MODULE: ./src/icons/arrow-previous.svg
var arrow_previous_path;
var arrow_previous_excluded = ["title", "titleId"];
function arrow_previous_extends() { return arrow_previous_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, arrow_previous_extends.apply(null, arguments); }
function arrow_previous_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = arrow_previous_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function arrow_previous_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgArrowPrevious(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = arrow_previous_objectWithoutProperties(_ref, arrow_previous_excluded);
  return /*#__PURE__*/react.createElement("svg", arrow_previous_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrow_previous_path || (arrow_previous_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  })));
}
/* harmony default export */ var arrow_previous = (SvgArrowPrevious);
;// CONCATENATED MODULE: ./src/components/PhotoSlider/index.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var buttonStyles = {
    fill: "white",
    svg: {
        height: "37px",
        width: "37px"
    }
};
var PhotoSlider_PhotoSlider = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(PhotoSlider/* default */.Z, _objectSpread({}, props, {
        buttonNext: /*#__PURE__*/ (0,jsx_runtime.jsx)((ButtonIcon_default()), {
            sx: buttonStyles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_next, {})
        }),
        buttonPrevious: /*#__PURE__*/ (0,jsx_runtime.jsx)((ButtonIcon_default()), {
            sx: buttonStyles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_previous, {})
        })
    }));
};
/* harmony default export */ var components_PhotoSlider = (PhotoSlider_PhotoSlider);

// EXTERNAL MODULE: ./src/components/MinifiedProductPanel/index.js
var MinifiedProductPanel = __webpack_require__(35660);
// EXTERNAL MODULE: ./src/components/InspirationCard/index.js
var InspirationCard = __webpack_require__(15845);
// EXTERNAL MODULE: ./src/sections/SectionWithConfigurableHeader/index.js
var SectionWithConfigurableHeader = __webpack_require__(44553);
// EXTERNAL MODULE: ./src/sections/Grid2Cards/index.js
var Grid2Cards = __webpack_require__(90485);
// EXTERNAL MODULE: ../API/dist/hooks/common/useAnalytics4AndCommerceTags.js
var useAnalytics4AndCommerceTags = __webpack_require__(79892);
;// CONCATENATED MODULE: ./src/pages/c/collection.js
















var CollectionPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var categoryProducts = props.categoryProducts, footerContent = props.footerContent, dataRequiredToHideLoader = props.dataRequiredToHideLoader, currentCategory = props.currentCategory, prismicData = props.prismicData, pagination = props.pagination, filtersString = props.filtersString, addToCartDisabled = props.addToCartDisabled, _totalCount = props.totalCount, totalCount = _totalCount === void 0 ? "" : _totalCount;
    var translations = {
        seoDescription: (0,langLibrary["default"])("Default seo description"),
        seoTitle: (0,langLibrary["default"])("Default seo title"),
        peopleLiked: (0,langLibrary["default"])("People also liked")
    };
    var viewList = (0,useAnalytics4AndCommerceTags["default"])().viewList;
    var isFirstRun = (0,react.useRef)(true);
    var collectionName = filtersString + ((ref = prismicData.content) === null || ref === void 0 ? void 0 : ref.categoryName) ? prismicData.content.categoryName : currentCategory.name;
    (0,react.useEffect)(function() {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            viewList(categoryProducts, collectionName);
        }
    });
    var collectionImages = [];
    ((ref1 = prismicData.content) === null || ref1 === void 0 ? void 0 : ref1.inspirationPage.length) > 0 && ((ref3 = (ref2 = prismicData.content) === null || ref2 === void 0 ? void 0 : ref2.inspirationPage[0].images) === null || ref3 === void 0 ? void 0 : ref3.map(function(inspirationImage) {
        collectionImages.push(inspirationImage.image);
    }));
    var currentPage = pagination.props.currentPage;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
        footerContent: footerContent,
        returnLinkLabel: null,
        onReturnLabelClick: null,
        minifiedMargin: true,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Grid_default()), {
                    cols: [
                        1,
                        1,
                        20,
                        20,
                        20
                    ],
                    children: [
                        (prismicData === null || prismicData === void 0 ? void 0 : (ref4 = prismicData.content) === null || ref4 === void 0 ? void 0 : ref4.inspirationPage) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                            sx: {
                                gridColumn: [
                                    "span 2",
                                    null,
                                    "span 9",
                                    null
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        display: [
                                            "block",
                                            null,
                                            "none"
                                        ],
                                        pt: "s10"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                                        titleAs: "h1",
                                        title: collectionName
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        position: [
                                            "relative",
                                            null,
                                            "sticky"
                                        ],
                                        top: [
                                            "s9",
                                            null,
                                            "100px",
                                            null,
                                            "10px"
                                        ]
                                    },
                                    children: collectionImages.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PhotoSlider, {
                                        slides: collectionImages,
                                        buttonNext: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_next, {}),
                                        buttonPrevious: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_next, {})
                                    }) : (collectionImages === null || collectionImages === void 0 ? void 0 : collectionImages[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                                        image: collectionImages === null || collectionImages === void 0 ? void 0 : collectionImages[0],
                                        sx: {
                                            width: "100%",
                                            objectFit: "cover",
                                            aspectRatio: 0.75,
                                            height: [
                                                "410px",
                                                null,
                                                null,
                                                "814px"
                                            ]
                                        },
                                        sizes: "(max-width: 1070px) and (min-width: 10px) 420px, 768px"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            sx: {
                                gridColumn: [
                                    "span 0",
                                    null,
                                    "span 1",
                                    null
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                            sx: {
                                gridColumn: [
                                    "span 2",
                                    null,
                                    "span 10",
                                    null
                                ],
                                mt: [
                                    "s3",
                                    null,
                                    "s11"
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        display: [
                                            "none",
                                            null,
                                            "block"
                                        ]
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                                        titleAs: "h1",
                                        title: ((ref5 = prismicData.content) === null || ref5 === void 0 ? void 0 : ref5.categoryName) ? "".concat(prismicData.content.categoryName, " (").concat(totalCount, ")") : "".concat(currentCategory.name, " (").concat(totalCount, ")")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        mb: "s10",
                                        mt: [
                                            "s10",
                                            null,
                                            null,
                                            "s11"
                                        ]
                                    },
                                    children: categoryProducts.map(function(product, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)((Box_default()), {
                                            sx: {
                                                mt: [
                                                    "s11",
                                                    null,
                                                    null,
                                                    "0px"
                                                ]
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinifiedProductPanel/* default */.Z, {
                                                showOptionsSelector: false,
                                                product: product,
                                                addToCartDisabled: addToCartDisabled
                                            })
                                        }, currentPage + "" + index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        mb: "s10"
                                    },
                                    children: pagination
                                }),
                                (prismicData === null || prismicData === void 0 ? void 0 : (ref6 = prismicData.content) === null || ref6 === void 0 ? void 0 : ref6.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                                    sx: {
                                        mt: [
                                            "s12",
                                            null,
                                            "0px"
                                        ]
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                            sx: {
                                                borderTop: "1px",
                                                borderTopColor: "neutral500",
                                                borderStyle: "solid",
                                                height: "1px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                            sx: {
                                                font: "base",
                                                color: "main",
                                                pt: "s9",
                                                pb: "s9",
                                                h5: {
                                                    font: "l",
                                                    pt: "0px",
                                                    pb: "0px",
                                                    m: "0px"
                                                },
                                                ul: {
                                                    mb: "s0"
                                                },
                                                p: {
                                                    my: "s7"
                                                },
                                                a: {
                                                    color: "main",
                                                    fontWeight: 700
                                                }
                                            },
                                            children: prismicData.content.description && prismic_reactjs.RichText.render(prismicData.content.description.content)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                            sx: {
                                                borderTop: "1px",
                                                borderTopColor: "neutral500",
                                                borderStyle: "solid",
                                                height: "1px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (prismicData === null || prismicData === void 0 ? void 0 : (ref7 = prismicData.content) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.inspirations) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                title: translations.peopleLiked,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2Cards/* default */.Z, {
                        children: prismicData.content.inspirations.map(function(inspiration, index) {
                            return inspiration && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                sx: {
                                    marginTop: index > 1 ? "s11" : 0,
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCard/* default */.Z, {
                                    inspiration: inspiration
                                }, index)
                            }, index);
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var collection = (CollectionPage);


/***/ })

}]);